import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'login-screen',
  templateUrl: `./login.screen.html`,
  styleUrls: [`./login.screen.scss`],
})
export class LoginScreenComponent implements OnInit {
  url: string;
  submitted = false;
  incorrectAttempt = false;
  loginClicked = false;
  success = true;
  roleError = true;
  errMessage: string;
  userLanguage: string;
  loginForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(8)]],
  });

  private errorCode = 401;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private fb: FormBuilder,
    private userApiService: UserApiService,
    private userService: UserService,
    public location_: Location,
  ) {}

  async ngOnInit() {
    localStorage.clear();
    this.userLanguage = navigator.language.substring(0, 2);
    if (this.userLanguage !== 'de') this.userLanguage = 'en';
    this.translate.setDefaultLang(this.userLanguage);
  }

  get fields() {
    return this.loginForm.controls;
  }

  login() {
    this.submitted = true;
    this.incorrectAttempt = false;
    if (this.loginForm.invalid) return;
    this.userApiService.login(this.loginForm.value).then(response => {
      if (!response.errors) {
        this.userApiService.checkUserRole(response['user']['role']).then(response => {
          if (!response) {
            this.roleError = false;
            this.navigate('/login');
            this.userService.clearToken();
          } else {
            this.url === this.location_.path()
              ? this.navigate('/registration-requests')
              : this.navigate(this.url);
          }
        });
      } else {
        response.code === this.errorCode ? (this.success = false) : (this.roleError = false);
      }
    });
  }

  navigate(url: string) {
    this.router.navigateByUrl(url);
  }
}
